module.exports = __webpack_public_path__ + "fonts/SofiaProExtraLight.1fd8846e.woff";